import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
// import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/product/new'));
const CreateProjectPage = lazy(() => import('src/pages/projects/createProject'));
const SingleProjectPage = lazy(() => import('src/pages/projects/singleProject'));

export const projectsRoutes = [
  {
    path: 'projects',
    element: (
      // <AuthGuard>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
      // </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'createproject', element: <CreateProjectPage /> },
      { path: 'editproject/:id', element: <CreateProjectPage /> },
      { path: ':string', element: <SingleProjectPage /> },
    ],
  },
  {
    path: 'projects/indent/:id',
    element: (
      // <AuthGuard>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
      // </AuthGuard>
    ),
    children: [{ element: <SingleProjectPage />, index: true }],
  },

  {
    path: 'projects/purchaseorderbymaterial/:id',
    element: (
      // <AuthGuard>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
      // </AuthGuard>
    ),
    children: [{ element: <SingleProjectPage />, index: true }],
  },

  {
    path: 'projects/purchaseorder/:id',
    element: (
      // <AuthGuard>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
      // </AuthGuard>
    ),
    children: [{ element: <SingleProjectPage />, index: true }],
  },

    {
    path: 'projects/requestorder/:id',
    element: (
      // <AuthGuard>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
      // </AuthGuard>
    ),
    children: [{ element: <SingleProjectPage />, index: true }],
  },

  {
    path: 'projects/grn/:id',
    element: (
      // <AuthGuard>
      <DashboardLayout>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
      // </AuthGuard>
    ),
    children: [{ element: <SingleProjectPage />, index: true }],
  },
];
